import SkeletonTrackerAssigner from "./skeletons/skeleton-tracker-assigner.js";

class SkeletonProperties {
    constructor(assigner) {
        this._skeletonTrackAssign = new SkeletonTrackerAssigner(assigner);
    }

    trackObjects(objects) {
        if (objects) {
            this._skeletonTrackAssign.trackObjects(objects.data, objects.events);
        } else {
            this._skeletonTrackAssign.trackObjects();
        }
    }

    trackSkeletons(skeletons) {
        if (skeletons) {
            this._skeletonTrackAssign.trackSkeletons(skeletons.data, skeletons.events);
        } else {
            this._skeletonTrackAssign.trackSkeletons();
        }
    }

    update() {
        this._skeletonTrackAssign.update();
    }
}

export default SkeletonProperties;
